export default __webpack_public_path__ + "static/media/rawpixel-coms.42432264.jpg";